"use client";

import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import type { YnsComponentForm } from "../types";
import type { SpecificationTable } from "./specification-table";

export const SpecificationTableForm: YnsComponentForm<typeof SpecificationTable> = ({ data }) => {
	const context = useStoreBuilderContext<typeof SpecificationTable>();

	return <div className="grid gap-4 relative pb-20">Form</div>;
};
